import utils from "../utils";

function init() {
	var mainNav = document.getElementById("main-nav"),
		mainMenuToggler = document.getElementById("main-nav-toggler"),
		htmlTag = document.getElementsByTagName("html")[0];

	if(mainMenuToggler){
		mainMenuToggler.addEventListener("click", () => {

			let isOpen = mainNav.classList.contains("open");
			if (isOpen) {
				mainMenuToggler.setAttribute("aria-expanded", "false");
				mainNav.classList.remove("open");
				htmlTag.classList.remove("no-scroll");
			} else {
				mainMenuToggler.setAttribute("aria-expanded", "true");
				mainNav.classList.add("open");
				htmlTag.classList.add("no-scroll");
			}
		});
	}

	if(mainNav){

		var menuItemHasChildren = mainNav.querySelectorAll('.menu-item-has-children > a');

		if(menuItemHasChildren.length > 0){	
			utils.forEach(menuItemHasChildren, function (index, elem) {
				elem.addEventListener("click", function (event) {

					event.preventDefault();

					if(elem.parentElement.classList.contains('visible')){
						elem.parentElement.classList.remove('visible');
					} else {
						elem.parentElement.classList.add('visible');
					}
				})
			});
		}
	}

}

export default { init };
